<template>
	<div class="news">
		<div class="site-content">
			<div class="page-header" :style="{backgroundImage:`url(${require('../assets/images/subheader.jpg')})`}" style="background:no-repeat center center;">
			    <div class="container">
			        <div class="breadc-box no-line">
			            <div class="row">
			                <div class="col-md-12">
			                    <h2 class="page-title">新闻动态</h2>
			                    <ul id="breadcrumbs" class="breadcrumbs none-style">
			                        <li><router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link></li>
			                        <li class="active">新闻动态</li>
			                    </ul>
			                </div>
			            </div>
			        </div>
			    </div>
			</div>
			<div class="entry-content">
				<div class="container">
					<div class="row">

						<div id="primary" class="content-area col-md-12 col-sm-12 col-xs-12">
						    <main id="main" class="site-main">
						    	<div class="row">

						    		<div class="col-md-4 col-sm-4 col-xs-12" v-for="(item,id) in newslist" :key="id">
								        <article class="post-box post type-post entry">
								            <div class="entry-media">
												<router-link :to="{ path: '/news_list/news', query: {id: item.id} }">
													<img :src="item.image" :alt="item.title">
												</router-link>
												
								            </div>
								            <div class="inner-post">
								                <header class="entry-header">

								                    <div class="entry-meta">
								                        <span class="posted-on">
								                        	<span class="entry-date published">{{dateFormat(item.time)}}</span>
								                        </span>
								                    </div>
								                    <!-- .entry-meta -->
								                    <h3 class="entry-title">
														<router-link :to="{ path: '/news_list/news', query: {id: item.id} }">
															{{item.title}}
														</router-link>
													</h3>
								                </header>
								                <!-- .entry-header -->

								                <div class="entry-summary">
								                    <p>{{item.desc}}</p>
								                </div>
								                <!-- .entry-content -->

								                <footer class="entry-footer">
								                    <a class="post-link">
														<router-link :to="{ path: '/news_list/news', query: {id: item.id} }">
															查看全文<i class="fa fa-plus-circle"></i>
														</router-link>
													</a>
								                </footer>
								                <!-- .entry-footer -->
								            </div>
								        </article>
								    </div>

								</div>

						        <!-- <ul class="page-pagination none-style">
						            <li><span aria-current="page" class="page-numbers current">1</span></li>
						            <li><a class="page-numbers" href="#">2</a></li>
						            <li><a class="page-numbers" href="#">3</a></li>
						            <li><a class="page-numbers" href="#">...</a></li>
						            <li><a class="page-numbers" href="#">23</a></li>
						            <li><a class="prev page-numbers" href="#"><i class="icon ion-ios-arrow-back"></i></a></li>
						            <li><a class="next page-numbers" href="#"><i class="icon ion-ios-arrow-forward"></i></a></li>
						        </ul> -->

						    </main>
						    <!-- #main -->
						</div>

						
					</div>
			    </div>
			</div>
		</div>
	</div>
</template>

<script> 	
	import $ from 'jquery'

	export default {
        name: 'news_list',  
		components: {},
		data(){
			return{
				newslist:[]
			}
		},
		created () {
			let that = this
			//数据请求
			this.$axios.get('/static/data.json').then(function(response){
				console.log(response);
				that.newslist = response.data.data.news;
			}).catch(function(error){
				console.log(error);
			})
		},
		methods:{	
			dateFormat:function(time) {
				var date=new Date(time);
				var year=date.getFullYear();
				var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
				var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
				var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
				var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
				var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
				// 拼接
				return year+"-"+month+"-"+day;
			}	  	
		},
		mounted(){
		}
	}

  
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/news_list.vue